import React from 'react';

const TeamsIntegrationDocs: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold mb-8 text-center">Teams Integration Docs</h1>
      <div className="space-y-6">
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Using Adaptive Cards</h2>
          <ol className="list-decimal pl-6 text-gray-700">
            <li>
              Go to <a href="https://make.powerautomate.com" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Power Automate</a>, sign in, and click on "Create Flow".
            </li>
            <li>
              Choose "When a Teams webhook request is received", accept the default parameters, and copy the HTTP URL. This is the URL you will provide to WeTrackSSL later.
            </li>
          </ol>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Step 2: Parse JSON</h2>
          <p className="text-gray-700">Add the "Parse JSON" flow next and use the following JSON schema:</p>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
{`{
    "type": "object",
    "properties": {
        "themeColor": {
            "type": "string"
        },
        "summary": {
            "type": "string"
        },
        "activityTitle": {
            "type": "string"
        },
        "Domain": {
            "type": "string"
        },
        "Message": {
            "type": "string"
        },
        "Status": {
            "type": "string"
        },
        "DaysRemaining": {
            "type": "integer"
        },
        "ExpiresOn": {
            "type": "string"
        }
    }
}`}
          </pre>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Step 3: Post Card in a Chat or Channel</h2>
          <p className="text-gray-700">Add the "Post card in a chat or channel" flow and configure the parameters:</p>
          <ul className="list-disc pl-6 text-gray-700">
            <li><strong>Post As:</strong> Flow Bot</li>
            <li><strong>Post In:</strong> Channel</li>
            <li><strong>Team:</strong> Select your team</li>
            <li><strong>Channel:</strong> Select a channel for the alert</li>
          </ul>
          <p className="text-gray-700 mt-4">Use the following Adaptive Card format:</p>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
{`{
    "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
    "type": "AdaptiveCard",
    "version": "1.0",
    "body": [
        {
            "type": "TextBlock",
            "text": "@{body('Parse_JSON')?['summary']}",
            "weight": "bolder",
            "color": "@{body('Parse_JSON')?['themeColor']}",
            "wrap": true
        },
        {
            "type": "FactSet",
            "facts": [
                {
                    "title": "Activity:",
                    "value": "@{body('Parse_JSON')?['activityTitle']}"
                },
                {
                    "title": "Domain:",
                    "value": "@{body('Parse_JSON')?['Domain']}"
                },
                {
                    "title": "Message:",
                    "value": "@{body('Parse_JSON')?['Message']}"
                },
                {
                    "title": "Status:",
                    "value": "@{body('Parse_JSON')?['Status']}"
                },
                {
                    "title": "Days Remaining:",
                    "value": "@{body('Parse_JSON')?['DaysRemaining']}"
                },
                {
                    "title": "Expires On:",
                    "value": "@{body('Parse_JSON')?['ExpiresOn']}"
                }
            ]
        }
    ]
}`}
          </pre>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Step 4: Save and Test</h2>
          <ol className="list-decimal pl-6 text-gray-700">
            <li>Save the flow.</li>
            <li>Head to the notification preferences in WeTrackSSL.</li>
            <li>Add the Teams webhook and test to ensure messages can be sent successfully.</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TeamsIntegrationDocs;
